import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { AppContext } from 'src/components/app-context';
import { H2Text, H3Text } from '@prisjakt/ui/text/variants';
import { FlipClock } from 'src/components/flip-clock';
import { NewsletterSignup } from 'src/components/newsletter-signup';
import { DAILY_DEALS_ID } from '../../../../globals/helpers/campaign/campaign-ids';
import ErrorBoundary from '../../../../components/error-boundary';
import CampaignDeals from '../../../../components/campaign-deals';
import { PopularStores } from '../popular-stores';
import ProductAlertBox from '../product-alert-box';
import CampaignArticles from '../campaign-articles';

import { PanelWithGutter, RowWithWrap, FlipClockWrapper } from './styles';

class CampaignInactive extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  render() {
    const { t, renderMode } = this.context;
    const { campaign, targetDate, dailyDeals, router, campaignDeals } =
      this.props;
    const { articles } = campaign;
    const featuredArticle = articles
      ? articles.find(item => item.featured)
      : null;
    const upcoming = campaign.state === 'UPCOMING';
    const legacyRenderMode = ['desktop', 'mobile', 'native'].includes(
      renderMode
    );

    return (
      <>
        <PanelWithGutter>
          {!legacyRenderMode && (
            <ProductAlertBox campaignName={campaign.name} />
          )}

          {upcoming && (
            <RowWithWrap>
              <FlipClockWrapper>
                <FlipClock
                  suppressHydrationWarning
                  targetDate={targetDate}
                  daysLabel={t('common', 'time.day', { n: 0 })}
                  hoursLabel={t('common', 'time.hour', { n: 0 })}
                  minutesLabel={t('common', 'time.minute', { n: 0 })}
                  secondsLabel={t('common', 'time.second', { n: 0 })}
                />
              </FlipClockWrapper>

              <NewsletterSignup
                title={t('campaigns', 'newsletter.sign-up-title', {
                  campaignName: campaign.name,
                })}
                description={t('campaigns', 'newsletter.sign-up-description')}
              />
            </RowWithWrap>
          )}
          <CampaignDeals deals={campaignDeals} />
        </PanelWithGutter>
        <ErrorBoundary onError={() => null}>
          <CampaignArticles
            featuredArticle={featuredArticle}
            articles={articles}
            campaignName={campaign.name}
          />
        </ErrorBoundary>
        <PopularStores
          dailyDeals={dailyDeals}
          campaignId={DAILY_DEALS_ID}
          router={router}
        />
        {!upcoming && (
          <PanelWithGutter>
            <H2Text>
              {t('campaigns', 'ended.title', { campaign: campaign.name })}
            </H2Text>
            <H3Text>{t('campaigns', 'ended.subtitle')}</H3Text>
          </PanelWithGutter>
        )}
      </>
    );
  }
}

const { string, number, shape, object } = PropTypes;

CampaignInactive.propTypes = {
  targetDate: number.isRequired,
  campaign: shape({
    title: shape({
      short: string,
      long: string,
    }),
    description: shape({
      short: string,
      long: string,
    }),
  }).isRequired,
  history: shape({
    location: shape({
      pathname: string,
      search: string,
    }),
  }).isRequired,
  router: shape({
    id: number,
  }).isRequired,
  dailyDeals: object,
};

CampaignInactive.defaultProps = {
  dailyDeals: undefined,
};

CampaignInactive.contextType = AppContext;

export default withRouter(CampaignInactive);
